import RatingStar from "@components/Icons/RatingStar";

const ProductReviewsChart = ({
  ratingDistribution,
  reviewsCount,
  changeRatingFilter,
  sortFilterData,
  hasRatingFilters,
}) =>
  [5, 4, 3, 2, 1].map((rating) => {
    const distribution = ratingDistribution[rating] || 0;
    const width = `${parseFloat((distribution * 100) / reviewsCount).toFixed(
      2
    )}%`;

    return (
      <div key={`rating-${rating}`} className="flex items-center mb-2">
        <div className="w-2 text-sm font-bold leading-15.6">{rating}</div>
        <div>
          <RatingStar className="w-13px h-13px ml-3px text-yellow" />
        </div>
        <div className="h-3 mx-3 relative overflow-hidden rounded-full grow bg-newGray">
          <div
            className={`absolute rounded-full top-0 left-0 bottom-0 ${
              {
                5: "bg-[#16B735]",
                4: "bg-[#C0DC26]",
                3: "bg-[#FDCD1A]",
                2: "bg-[#FD672C]",
                1: "bg-[#D71541]",
              }[rating]
            }`}
            style={{ width }}
          ></div>
        </div>
        <div className="w-20 text-sm text-red-brand leading-15.6">
          {hasRatingFilters && distribution !== 0 ? (
            <span
              className="underline underline-offset-4 cursor-pointer"
              onClick={() => changeRatingFilter({ ...sortFilterData, rating })}
            >
              {distribution === 1 ? "1 recenzie" : `${distribution} recenzii`}
            </span>
          ) : (
            <span>
              {distribution === 1 ? "1 recenzie" : `${distribution} recenzii`}
            </span>
          )}
        </div>
      </div>
    );
  });

export default ProductReviewsChart;
